<template>
	<div class="gvf">
		<v-text-field
			v-model="value"
			clearable
			:tabindex="tabIndex"
			:value="value"
			:label="gridViewField.Label"
			prepend-icon="mdi-calendar"
			hide-details="auto"
			dense
			outlined
			@change="changeValue()"
			:rules="[valueRule]"
			:placeholder="dateTimeFormat"
		>
		</v-text-field>
		<v-checkbox
			v-if="isBulkEdit"
			v-model="isNull"
			label="Set field to null"
			class="ma-0"
			hide-details
			@change="changeValue()"
		></v-checkbox>
	</div>
</template>
<script>
import gridViewFieldsUtils from '../../../../utils/gridViewFieldsUtils';
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
import projectSettingsMixin from '../../../../mixins/projectSettingsMixin';
import fieldsValidationRules from '../../../../utils/fieldsValidationRules';
import moment from 'moment';
export default {
	name: 'DatetimeField',
	mixins: [gridFieldMixin, projectSettingsMixin],
	data() {
		return {
			menu: false,
			value: null,
		};
	},
	computed: {
		validations() {
			return fieldsValidationRules;
		},
		valueRule() {
			return this.validations.validationDateNullable(
				this.value,
				this.getDateTimeFormatProjectSetting()
			);
		},
	},
	mounted() {
		if (this.record && this.key && this.record[this.key]) {
			this.value = this.getDateTimeFormat(this.record[this.key]);
		}
	},

	methods: {
		convertDateTimeFormLocaleToUtc(valueLocale) {
			if (!valueLocale) return null;
			let momentlocale = moment(valueLocale);
			let format = this.getDateTimeFormatProjectSetting();
			let utc = momentlocale.utc().format(format + ' Z');
			return utc;
		},
		changeValue() {
			let recordKey;
			if (this.isNull) {
				recordKey = [{ key: this.key, value: null }];
				this.value = null;
			} else {
				recordKey = [
					{
						key: this.key,
						value: this.convertDateTimeFormLocaleToUtc(this.value),
					},
				];
			}
			let itemKey = [
				{
					key: gridViewFieldsUtils.getFieldName(this.gridViewField),
					value: this.convertDateTimeFormLocaleToUtc(this.value),
				},
			];
			this.$emit('valueChanged', itemKey, recordKey, this.isNull);
		},
	},
};
</script>
